

export interface DeductionRateDataForm {
    id?: number;
    deduction_id?: number;
    value?: number;
    currency?: string;
    currency_id?: number;
    valid_from?: string;
    valid_until?: string;
    deduction_type?: string;
    formula?: string;
    deduction_basis?: string;
}

export interface DeductionRateFilters {
    deduction_rate_id?: number | null;

    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export interface ValueType {
    id: number | string;
    name: number | string;
}

export const defaultDeductionRateDataForm: DeductionRateDataForm = {
    deduction_type: '',
    deduction_basis: ''
};